module.exports = __webpack_public_path__ + "img/041.6d4f1b37.jpg";